import script from "./LoginAdPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginAdPopup.vue?vue&type=script&setup=true&lang=js"

import "./LoginAdPopup.vue?vue&type=style&index=0&id=0a18d24a&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a18d24a"]])

export default __exports__